import { addToCart, lineItemProperties } from "./add-to-cart";

export class ProductItem extends HTMLElement {
  constructor() {
    super();
    // Parse JSON once
    this._variants = this.dataset.variants ? JSON.parse(this.dataset.variants) : null;
    this._collection = this.dataset.collection ? JSON.parse(this.dataset.collection) : null;
    this._addedFrom = this.dataset.addedFrom;

    // Store DOM references
    this._elements = {
      variantInput: this.querySelector('input[name="variant-id"]'),
      atcButtons: Array.from(this.querySelectorAll(".js-atc-button")),
    };
    // Bind once
    this._boundAddToCard = this._addToCard.bind(this);
  }

  connectedCallback() {
    // Use event delegation instead of multiple listeners
    this._elements.atcButtons.forEach((button) =>
      button.addEventListener("click", this._boundAddToCard)
    );
  }

  disconnectedCallback() {
    // Cleanup
    this._elements.atcButtons.forEach((button) =>
      button.removeEventListener("click", this._boundAddToCard)
    );
  }

  async _addToCard(e) {
    e.preventDefault();

    await addToCart(
      [
        {
          id: this.variantId,
          quantity: 1,
          properties: lineItemProperties({
            author: this.author,
            collection: this._collection,
            addedFrom: this._addedFrom,
          }),
        },
      ],
      {
        klaviyoItems: [this.atcKlaviyoEventData],
        eventData: this.atcEventData,
      }
    );
  }

  get variantId() {
    return this._elements.variantInput?.value;
  }

  get variants() {
    return this._variants; // Return cached value
  }

  set variantId(value) {
    this._variantInput.value = value;
  }

  get author() {
    return this.dataset.author;
  }

  get isbn() {
    return this.dataset.isbn;
  }

  get atcEventData() {
    const eventData = this.dataset.atcEventData
      ? JSON.parse(this.dataset.atcEventData)
      : { cloud_retail: {} };
    eventData.cloud_retail.attributionToken = sessionStorage.getItem("attributionToken")
      ? sessionStorage.getItem("attributionToken")
      : null;
    eventData.cloud_retail.visitorId = localStorage.getItem("visitorId");
    eventData.cloud_retail.cartId = window.cartToken;
    if (window.userId && window.userId !== '') {
      eventData.cloud_retail.userInfo = { userId: window.userId };
    }
    return eventData;
  }

  get atcKlaviyoEventData() {
    return this.dataset.atcKlaviyoEventData ? JSON.parse(this.dataset.atcKlaviyoEventData) : null;
  }
}

if (!customElements.get("product-item")) {
  customElements.define("product-item", ProductItem);
}
